import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { GoogleAnalyticsEventType } from 'enums/GoogleAnalyticsEventType';
import { CuroAppRoute } from 'enums/curo/CuroAppRoute';
import { useAppProgressBar } from 'hooks/useAppProgressBar';
import useGoogleAnalytics from 'hooks/useGoogleAnalytics';
import CuroMainLayout from 'layout/CuroMainLayout';

import WelcomeStep from './WelcomeStep';

const MailOfferProcess = () => {
  const navigate = useNavigate();
  const trackEvent = useGoogleAnalytics();
  const { resetProgress } = useAppProgressBar();

  useEffect(() => {
    resetProgress();
    trackEvent(GoogleAnalyticsEventType.DmWelcome);
  }, []);

  return (
    <CuroMainLayout>
      <WelcomeStep
        onStepComplete={() => navigate(CuroAppRoute.MailOfferNextSteps)}
        onStepEnd={() => navigate(CuroAppRoute.ApplyProcess)}
      />
    </CuroMainLayout>
  );
};

export default MailOfferProcess;
